import { ModelConfigParams, lungChecklistMFG, lungChecklistQC } from "./model-config-params";

export const lungCurie: ModelConfigParams = {
  bodyParts: [
    'tumour',
    'airwayWithDetail',
    'unknown',
    'veinCurieWithDetail',
    'arteryCurieWithDetailAndSegments',
    'lobeLeftSuperiorCurie',
    'lobeLeftInferiorCurie',
    'lobeRightSuperiorCurie',
    'lobeRightMedialCurie',
    'lobeRightInferiorCurie',
    'bone',
    'aorta',
    'heartWithChambers',
    'oesophagus',
    'tumourMargin',
    'cyst',
  ],
  tissueHotkeys: {
    tumour: 'q',
    artery: 'w',
    vein: 'e',
    airway: 'r',
    arteryDetail: "t",
    veinDetail: "y",
    airwayDetail: "u",
    arteryUncertain: "i",
    veinUncertain: "o",
    unknown: "p",
    lobeLeftSuperiorCurie: "alt + 1",
    lobeLeftInferiorCurie: "alt + 2",
    lobeRightSuperiorCurie: "alt + 3",
    lobeRightMedialCurie: "alt + 4",
    lobeRightInferiorCurie: "alt + 5",
  },
  checklist: lungChecklistMFG,
  checklistQC: lungChecklistQC,
  defaultIntensityRange: [-1000, 300],
}
